/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shirt': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M14 35V11a1 1 0 011-1h9M14 41v10a1 1 0 001 1h30a1 1 0 001-1V11a1 1 0 00-1-1h-9M14 39v-2" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="1" d="M14 24.388L3.316 27.949A1.001 1.001 0 012 27V15c0-.441.286-.816.684-.949l12-4M46 24.388l10.684 3.562A1 1 0 0058 27V15c0-.441-.287-.816-.684-.949l-12-4M30 21v8M30 31v2M30 35v17M21 25v27M39 27v25M39 23v2" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="2" d="M37 10a7 7 0 11-14 0" _stroke="#000230" stroke-width="2"/>'
  }
})
